import axios from 'axios'
import {
	// Message,
	Loading
} from 'element-ui'
import {
	AXIOS_API
} from "@/urlConfig"
// vuex
import store from '@/store'
import {
	getToken
} from './auth.js'

//router
import router from "../router"

// loading
var loadingInstance = ''

// console.log debug style
var debug = 'color: yellow; font-style: italic; background-color: blue;padding: 2px'

// create an axios instance
const javaService = axios.create({
	// withCredentials: true, // send cookies when cross-domain requests
	// baseURL: 'http://192.168.2.167:8899/xboot',
	baseURL: AXIOS_API,
	// baseURL: 'http://192.168.4.2:8899/xboot',
	timeout: 5000, // request timeout
	// retry: 3, //全局重连请求次数
	retryDelay: 1000, //设置全局请求间隔
})
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
/* 默认值 */
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// request interceptor
javaService.interceptors.request.use(
	config => {
		// do something before request is sent
		if (store.state.token) {
			config.headers['accessToken'] = getToken()
		}

		// 是否要去加载
		if (config.isLoading) {
			loadingInstance = Loading.service({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})
		}
		return config
	},
	error => {
		// 取消加载
		if (loadingInstance !== '') {
			loadingInstance.close()
		}
		// do something with request error
		console.log(`%crequest err for debug : ${error}`, debug) // for debug
		return Promise.reject(error)
	}
)


javaService.interceptors.response.use(response => {
		const res = response.data
		// 取消加载
		if (loadingInstance !== '') {
			loadingInstance.close()
		}
		// if the custom code is not 20000, it is judged as an error.
		const code = `${res.code}`
		if (code == '200') {
			return res
		}
	},
	(error) => {
		if (loadingInstance !== '') {
			loadingInstance.close()
		}
		var config = error.config;
		console.dir(error)
		if (!config) return Promise.reject(error)

		if (error.message === "Network Error") {
			// Message({
			// 	message: '网络链接已断开,请检查网路',
			// 	type: 'warning',
			// 	duration: 5 * 1000
			// })
			router.push({path:'/404'})

		} else if (error.message === "timeout of 5000ms exceeded") {
			
			router.push({path:'/404'})
		} else {
			
			router.push({path:'/404'})
		}

	});

export default javaService
